// extracted by mini-css-extract-plugin
module.exports = {"block":"_2hUPIQg"};
    if(module.hot) {
      // 1545369437785
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  